.center {
  text-align: center;
}

.pageHeight {
  padding: 70px 0;
  height: calc(100vh - 100px);
}
